import { AbstractObjectRegistry } from "@mcleod/core";
import { Behavior } from "./Behavior";

export class BehaviorTypes {
    public static register<T extends Behavior>(object: T): void {
        BehaviorTypeRegistry.instance.register(object);
    }

    public static get<T extends Behavior>(type: string): T {
        const behaviorConstructor: any = BehaviorTypeRegistry.instance.getObject(type)?.constructor;
        if (behaviorConstructor == null)
            throw new Error("Could not find behavior for type: " + type);
        return new behaviorConstructor() as T;
    }
}

class BehaviorTypeRegistry extends AbstractObjectRegistry<Behavior> {
    private static _instance: BehaviorTypeRegistry;

    private constructor() { super(); }

    public static get instance(): BehaviorTypeRegistry {
        if (!BehaviorTypeRegistry._instance) {
            BehaviorTypeRegistry._instance = new BehaviorTypeRegistry();
        }
        return BehaviorTypeRegistry._instance;
    }
}
